import {
  ADD_CHATTER_CLIENT,
  ADD_FUNDING_SOURCE,
  ADD_HOME_EDUCATION,
  ADD_PRIVATE_CLIENT,
  CHATTER_CLIENT_LIST,
  CHATTER_LESSON_ADD,
  CHATTER_LESSON_DETAILS,
  CHATTER_LESSON_EDIT,
  CHATTER_LESSON_LIST,
  CHATTER_PEER_ADD,
  CHATTER_PEER_DETAILS,
  CHATTER_PEER_EDIT,
  CHATTER_PEER_LIST,
  CHATTER_PEER_REFERENCE_LETTER,
  CHATTER_PROGRAM_ADD,
  CHATTER_PROGRAM_DETAILS,
  CHATTER_PROGRAM_EDIT,
  CHATTER_PROGRAM_LIST,
  DESIGNATIONS_ADD,
  DESIGNATIONS_EDIT,
  DESIGNATIONS_LIST,
  DISCIPLINES_ADD,
  DISCIPLINES_EDIT,
  DISCIPLINES_LIST,
  EDIT_CHATTER_CLIENT,
  EDIT_FUNDING_SOURCE,
  EDIT_HOME_EDUCATION,
  EDIT_PRIVATE_CLIENT,
  FUNDING_SOURCE_LIST,
  GOALS_ADD,
  GOALS_EDIT,
  GOALS_LIST,
  HOME_EDUCATION_CREATE_INTAKE_REPORT,
  HOME_EDUCATION_LIST,
  MANAGE_CMS_ADD,
  MANAGE_CMS_EDIT,
  MANAGE_CMS_LIST,
  MANAGE_NOTIFICATION_EMAIL_TEMPLATE_ADD,
  MANAGE_NOTIFICATION_EMAIL_TEMPLATE_EDIT,
  MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST,
  MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_ADD,
  MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_EDIT,
  MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST,
  MANAGE_PARENTS_ADD,
  MANAGE_PARENTS_EDIT,
  MANAGE_PARENTS_LIST,
  MANAGE_STATUS_ADD,
  MANAGE_STATUS_EDIT,
  MANAGE_STATUS_LIST,
  MANAGE_SUPPORT_STAFF_ADD,
  MANAGE_SUPPORT_STAFF_EDIT,
  MANAGE_SUPPORT_STAFF_LIST,
  MANAGE_SUPPORT_STAFF_VIEW,
  MANAGE_TEACHERS_ADD,
  MANAGE_TEACHERS_EDIT,
  MANAGE_TEACHERS_LIST,
  MDT_ASSESSMENT_ADD,
  MDT_ASSESSMENT_DETAILS,
  MDT_ASSESSMENT_EDIT,
  MDT_ASSESSMENT_LIST,
  MDT_STATUS_ADD,
  MDT_STATUS_EDIT,
  MDT_STATUS_LIST,
  MDT_TERMS_ADD,
  MDT_TERMS_EDIT,
  MDT_TERMS_LIST,
  PRIVATE_CLIENT_LIST,
  SCHOOL_ADD,
  SCHOOL_CLIENT_ADD,
  SCHOOL_CLIENT_DETAIL,
  SCHOOL_CLIENT_EDIT,
  SCHOOL_CLIENT_LIST,
  SCHOOL_DIVISON_ADD,
  SCHOOL_DIVISON_EDIT,
  SCHOOL_DIVISON_LIST,
  SCHOOL_EDIT,
  SCHOOL_LIST,
  SERVICE_STATUS_ADD,
  SERVICE_STATUS_EDIT,
  SERVICE_STATUS_LIST,
  THERAPIST_ADD,
  THERAPIST_DETAIL,
  THERAPIST_EDIT,
  THERAPIST_LIST,
  VIEW_CHATTER_CLIENT,
  VIEW_FUNDING_SOURCE,
  VIEW_HOME_EDUCATION,
  VIEW_PRIVATE_CLIENT,
  MANAGE_USERS_LIST,
  MANAGE_USERS_ROLE,
  MANAGE_USERS_VIEW,
  MANAGE_USERS_ADD,
  PROFILE,
  ACCOUNT_VERIFICATION,
  POLICY_AND_PROCEDURE,
  POLICY_AND_PROCEDURE_PREVIEW,
  MANAGE_EXPORT,
  MANAGE_CONSENT_FORM,
  MANAGE_CONSENT_ADD,
  VIEW_REPORT,
  MANAGE_CONSENT_EDIT,
  MANAGE_USERS_EDIT,
  MANAGE_PARENTS_DETAILS,
  APPOINTMENT_ADD,
  APPOINTMENT_LIST,
  APPOINTMENT_DETAILS,
  APPOINTMENT_FORMS_VIEW,
  APPOINTMENT_EDIT,
  APPOINTMENT_SERVICES_LIST,
  APPOINTMENT_SERVICES_ADD,
  APPOINTMENT_SERVICES_EDIT,
  APPOINTMENT_INVOICE_LIST,
  APPOINTMENT_INVOICE_VIEW,
  MANAGE_SUPPORT_STAFF_CLIENT_TASKS,
  MANAGE_SUPPORT_STAFF_CLIENT_TASKS_SESSION_VIEW,
  MANAGE_STAFF_GROUP_TASK_LIST,
  MANAGE_STAFF_GROUP_SESSION_VIEW,
  MANAGE_CONSENT_CHECKLISTS_LIST,
  MANAGE_CONSENT_CHECKLISTS_UPDATE,
  MANAGE_CONSENT_CHECKLISTS_ADD,
  CLIENT_CONSENT_FORMS_LIST,
  CLIENT_ASSIGNED_COSNENT_FORMS_VIEW,
  MANAGE_PARENT_TASKS_LIST,
  MANAGE_PARENT_TASK_SESSION_VIEW,
  DISCHARGES,
  ASSESSMENT_TEMPLATE_LIST,
  ASSESSMENT_TEMPLATE_ADD,
  ASSESSMENT_TEMPLATE_EDIT,
  CHATTER_TEMPLATE_LIST,
  CHATTER_TEMPLATE_ADD,
  CHATTER_TEMPLATE_EDIT,
  UNAUTHORIZED_ACCESS,
  HOME_EDUCATION_CREATE_INTAKE_REPORT_V2,
  AUDIT_LOGS,
  CLASSROOM_CONSULTATIONS,
  WORKSHOPS,
  WORKSHOP_ADD,
  WORKSHOP_EDIT,
  WORKSHOP_VIEW,
  NOTES_TABLE,
  CREATE_NOTES,
  EDIT_NOTES,
  CLIENT_SERVICE_STATUS_LIST,
  CLIENT_ATTENDANCE_LIST,
  CLIENT_DOCUMENTS_LIST,
  DIAGNOSIS_SERVERITY,
  CLIENT_REPORTS_LIST,
  CLINICIANS_HISTORY,
  CHATTER_PEER_REFERENCE_LETTER_V2,
  SUBADMIN_ONBOARD,
  CHATTER_CLIENT_ATTENDANCE,
  SCHOOL_BANNERS_LIST,
  SCHOOL_BANNERS_ADD,
  SCHOOL_BANNERS_EDIT,
  MANAGE_COORDINATORS_LIST,
  MANAGE_COORDINATORS_ADD,
  MANAGE_COORDINATORS_EDIT,
  NOTIFICATIONS,
  MANAGE_NOTIFICATIONS,
  MANAGE_NOTIFICATION_USERS,
  MANAGE_NOTIFICATION_USER_FEED,
  NOTIFICATION_TEMPLATES,
  NOTIFICATION_TEMPLATES_EDIT,
  POLICY_AND_PROCEDURE_V2,
  POLICY_AND_PROCEDURE_V2_ADD,
  POLICY_AND_PROCEDURE_V2_DETAIL,
  POLICY_AND_PROCEDURE_V2_EDIT,
  THERAPIST_ASSIGNED_CLIENTS,
  MDT_ASSESSMENT_DOCUMENTS,
  SCHOOL_BANNERS_VIEW,
} from "config/paths";
import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import ClientChatter from "./SideTabPages/Clients/Chatter";
import AddClientChatter from "./SideTabPages/Clients/Chatter/Add";
import ClientChatterDetail from "./SideTabPages/Clients/Chatter/detail";
import HomeEducation from "./SideTabPages/Clients/HomeEducation";
import AddClientHome from "./SideTabPages/Clients/HomeEducation/Add";
import ClientHomeDetail from "./SideTabPages/Clients/HomeEducation/detail";
import ClientPrivate from "./SideTabPages/Clients/Private";
import AddClientPrivate from "./SideTabPages/Clients/Private/Add";
import ClientPrivateDetail from "./SideTabPages/Clients/Private/detail";
import ClientSchool from "./SideTabPages/Clients/School";
import AddClientSchool from "./SideTabPages/Clients/School/Add";
import ClientSchoolDetail from "./SideTabPages/Clients/School/detail";
import Designations from "./SideTabPages/Designations";
import AddDesignation from "./SideTabPages/Designations/Add";
import ChatterPeer from "./SideTabPages/ManageChatter/ChatterPeer";
import ChatterPeerAdd from "./SideTabPages/ManageChatter/ChatterPeer/Add";
import ChatterPeerDetail from "./SideTabPages/ManageChatter/ChatterPeer/detail";
import ChatterLessonPlan from "./SideTabPages/ManageChatter/LessonPlan";
import ChatterLessonPlanAdd from "./SideTabPages/ManageChatter/LessonPlan/Add";
import ChatterLessonDetail from "./SideTabPages/ManageChatter/LessonPlan/detail";
import ChatterProgramFiles from "./SideTabPages/ManageChatter/ProgramFiles";
import AddChatterProgramFiles from "./SideTabPages/ManageChatter/ProgramFiles/Add";
import ChatterProgramFilesDetail from "./SideTabPages/ManageChatter/ProgramFiles/detail";
import DisciplineProfile from "./SideTabPages/ManageDiscipline/DisciplineProfile";
import AddDiscipline from "./SideTabPages/ManageDiscipline/DisciplineProfile/Add";
import AllGoals from "./SideTabPages/ManageGoals/AllGoals";
import AddGoals from "./SideTabPages/ManageGoals/AllGoals/Add";
import ManageMDTTerms from "./SideTabPages/ManageMDT/MDTTerms";
import AddMDTTerms from "./SideTabPages/ManageMDT/MDTTerms/Add";
import ManageMDTStatus from "./SideTabPages/ManageMDT/ManageStatus";
import AddMDTStatus from "./SideTabPages/ManageMDT/ManageStatus/Add";
import Multidisciplinary from "./SideTabPages/ManageMDT/Multidisciplinary";
import AddMultidisciplinaryAssessment from "./SideTabPages/ManageMDT/Multidisciplinary/Add";
import MultidisciplinaryDetail from "./SideTabPages/ManageMDT/Multidisciplinary/detail";
import PCFundingSource from "./SideTabPages/ManagePrivateClient/FundingSource";
import AddFundingSource from "./SideTabPages/ManagePrivateClient/FundingSource/Add";
import PCFundingSourceDetail from "./SideTabPages/ManagePrivateClient/FundingSource/detail";
import SchoolDivision from "./SideTabPages/ManageSchool/SchoolDivision";
import AddSchoolDivision from "./SideTabPages/ManageSchool/SchoolDivision/Add";
import SchoolProfile from "./SideTabPages/ManageSchool/SchoolProfile";
import AddSchool from "./SideTabPages/ManageSchool/SchoolProfile/Add";
import ManageTeamTherapists from "./SideTabPages/ManageTeam/TherapistProfile";
import AddTherapist from "./SideTabPages/ManageTeam/TherapistProfile/Add";
import TherapistDetail from "./SideTabPages/ManageTeam/TherapistProfile/detail";
import ServiceStatus from "./SideTabPages/ServiceStatus";
import AddServiceStatus from "./SideTabPages/ServiceStatus/Add";
import ClientManageStatus from "./SideTabPages/Clients/ManageStatus";
import ClientAddManageStatus from "./SideTabPages/Clients/ManageStatus/Add";
import CreatePeerReferenceLetter from "./SideTabPages/ManageChatter/ChatterPeer/ReferenceLetter";
import ManageParents from "./SideTabPages/ManageParents/index";
import AddParent from "./SideTabPages/ManageParents/Add";
import ManageTeachers from "./SideTabPages/ManageTeacher";
import AddTeacher from "./SideTabPages/ManageTeacher/Add";
import AddSupportStaff from "./SideTabPages/ManageSupportStaff/Add";
import ManageSupportStaff from "./SideTabPages/ManageSupportStaff";
import SupportStaffDetails from "./SideTabPages/ManageSupportStaff/Details";
import ManageCms from "./SideTabPages/Cms";
import AddCms from "./SideTabPages/Cms/Add";
import ManageNotificationTemplate from "./SideTabPages/EmailNotificationTemplate";
import AddNotificationTemplate from "./SideTabPages/EmailNotificationTemplate/Add";
import ManageFirebaseNotificationTemplate from "./SideTabPages/FirebaseNotification";
import AddFirebaseNotificationTemplate from "./SideTabPages/FirebaseNotification/Add";
import IntakeReport from "./SideTabPages/Clients/HomeEducation/IntakeReport/Index";
import ManageSubAdmin from "./SideTabPages/ManageSubAdmin";
import ManageUserDetails from "./SideTabPages/ManageSubAdmin/Details";
import AddSubAdmin from "./SideTabPages/ManageSubAdmin/Add";
import Profile from "./SideTabPages/Profile";
import ActivateAccount from "./AuthPages/ActivateAccount/Index";
import PolicyAndProcedure from "./SideTabPages/PolicyAndProcedures";
import PolicyAndProceduresPreview from "./SideTabPages/PolicyAndProcedures/Preview";
import ManageExport from "./SideTabPages/Export";
import ManageConsent from "./SideTabPages/Consent";
import AddConsent from "./SideTabPages/Consent/Add";
import ViewReport from "components/shared/ViewReport/Index";
import AddAppointment from "./SideTabPages/Appointments/Add";
import ViewAppointment from "./SideTabPages/Appointments/View";
import ParentDetail from "./SideTabPages/ManageParents/detail";
import AppointmentDetail from "./SideTabPages/Appointments/detail";
import AppointmentFormsView from "./SideTabPages/Appointments/FormView";
import AppointmentServices from "./SideTabPages/AppointmentServices";
import AddAppointmentServices from "./SideTabPages/AppointmentServices/Add";
import AppointmentInvoices from "./SideTabPages/AppointmentInvoices/index";
import ClientTasks from "./SideTabPages/ManageSupportStaff/ClientTasks";
import ClientTaskSessionView from "./SideTabPages/ManageSupportStaff/TaskSessionView";
import GroupTasks from "./SideTabPages/ManageSupportStaff/GroupTasks";
import GroupTaskSession from "./SideTabPages/ManageSupportStaff/GroupTasks/GroupTasksSession";
import ManageConsentCheckLists from "./SideTabPages/ManageParents/ManageConsentChecklists";
import AddConsentCheckLists from "./SideTabPages/ManageParents/ManageConsentChecklists/Add";
import ConsentForms from "./SideTabPages/ManageParents/detail/ConsentFoms";
import AppointmentInvoiceDetail from "./SideTabPages/AppointmentInvoices/Detail/index";
import AssignedConsentFormView from "./SideTabPages/ManageParents/detail/ConsentFoms/FormView";
import ParentTasksList from "./SideTabPages/ManageParents/detail/Tasks/List";
import ParentTaskSessionView from "./SideTabPages/ManageParents/detail/Tasks/List/ParentTaskSessionView";
import Discharges from "./SideTabPages/Clients/Discharges";
import AssessmentTemplates from "./SideTabPages/AssessmentTemplates";
import AssessmentTemplatesAdd from "./SideTabPages/AssessmentTemplates/Add";
import ChatterTemplates from "./SideTabPages/ChatterTemplates";
import ChatterTemplatesAdd from "./SideTabPages/ChatterTemplates/Add";
import IntakeReportV2 from "./SideTabPages/Clients/HomeEducation/IntakeReportV2";
import AuditLogs from "./SideTabPages/AuditLogs";
import ClassroomConsultations from "./SideTabPages/Clients/classroom-consultations/ClassroomConsultations";
import Workshops from "./SideTabPages/Workshop";
import AddWorkshop from "./SideTabPages/Workshop/Add";
import WorkshopView from "./SideTabPages/Workshop/View";
import NotesTable from "./SideTabPages/Notes/NotesTable";
import AddNotesForm from "./SideTabPages/Notes/Add";
import ServiceStatusPage from "components/shared/FormComponents/V2/CliniciansAssigned/ServiceStatusPage";
import AttendanceTracker from "components/shared/FormComponents/V2/Attendance/AttendanceTrack";
import DiagnosisPage from "components/shared/FormComponents/V2/Diagnosis/DiagnosisPage";
import ReportsPage from "components/shared/FormComponents/V2/ReportsComponent/ReportsPage";
import ClientAttachmentsPage from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachmentsPage";
import CliniciansHistory from "components/shared/FormComponents/V2/CliniciansAssigned/CliniciansHistory";
import VolunteerReferenceLetter from "./SideTabPages/ManageChatter/ChatterPeer/ReferenceLetter/V2";
import SubAdminOnboard from "./SideTabPages/Onboard/SubAdminOnboard";
import ChatterAttendanceTracker from "components/shared/FormComponents/V2/ChatterAttendance/ChatterAttendanceTrack";
import SchoolBannersList from "./SideTabPages/ManageSchoolBanners";
import AddBanner from "./SideTabPages/ManageSchoolBanners/Add/AddBanner";
import ManageCoordinators from "./SideTabPages/ManageCoordinator";
import AddCoordinator from "./SideTabPages/ManageCoordinator/Add";
import Notifications from "./SideTabPages/Notifications";
import ManageNotifications from "./SideTabPages/ManageNotifications";
import ManageNotificationUsers from "./SideTabPages/ManageNotifications/Users";
import ManageNotificationUserFeed from "./SideTabPages/ManageNotifications/UserFeed";
import NotificationTemplates from "./SideTabPages/NotificationTemplates";
import EditNotifications from "./SideTabPages/NotificationTemplates/Edit/EditNotifications";
import PoliciesAndProceduresV2 from "./SideTabPages/PoliciesAndProceduresV2";
import AddPolicyAndProcedureV2 from "./SideTabPages/PoliciesAndProceduresV2/Add";
import PolicyAndProcedureDetailV2 from "./SideTabPages/PoliciesAndProceduresV2/Detail";
import AssignedClientsToTherapist from "./SideTabPages/ManageTeam/TherapistProfile/AssingedClients/AssignedClientsToTherapist";
import MdtClientAttachmentsPage from "components/shared/FormComponents/V2/ClientAttachments/mdtClientAttachments";
import ViewSchoolBanner from "./SideTabPages/ManageSchoolBanners/View";
// import ClientAttachmentsPage from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachmentsPage";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: "/reset-password/:token", component: <ResetPassword /> },
  { path: ACCOUNT_VERIFICATION, component: <ActivateAccount /> },
];

export const privateRoutes = [
  { path: SCHOOL_CLIENT_LIST, component: <ClientSchool />, module: "client_school", action: "view" },
  { path: SCHOOL_CLIENT_ADD, component: <AddClientSchool />, module: "client_school", action: "view" },
  { path: SCHOOL_CLIENT_EDIT, component: <AddClientSchool />, module: "client_school", action: "view" },
  { path: SCHOOL_CLIENT_DETAIL, component: <ClientSchoolDetail />, module: "client_school", action: "view" },
  { path: HOME_EDUCATION_LIST, component: <HomeEducation />, module: "client_home", action: "view" },
  { path: ADD_HOME_EDUCATION, component: <AddClientHome />, module: "client_home", action: "view" },
  { path: EDIT_HOME_EDUCATION, component: <AddClientHome />, module: "client_home", action: "view" },
  { path: VIEW_HOME_EDUCATION, component: <ClientHomeDetail />, module: "client_home", action: "view" },
  { path: HOME_EDUCATION_CREATE_INTAKE_REPORT, component: <IntakeReport />, module: "client_school", action: "view" },
  { path: HOME_EDUCATION_CREATE_INTAKE_REPORT_V2, component: <IntakeReportV2 />, module: "client_school", action: "view" },
  { path: MANAGE_STATUS_LIST, component: <ClientManageStatus />, module: "client_status", action: "view" },
  { path: MANAGE_STATUS_ADD, component: <ClientAddManageStatus />, module: "client_status", action: "view" },
  { path: MANAGE_STATUS_EDIT, component: <ClientAddManageStatus />, module: "client_status", action: "view" },
  { path: CHATTER_CLIENT_LIST, component: <ClientChatter />, module: "client_chatter", action: "view" },
  { path: VIEW_CHATTER_CLIENT, component: <ClientChatterDetail />, module: "client_chatter", action: "view" },
  { path: ADD_CHATTER_CLIENT, component: <AddClientChatter />, module: "client_chatter", action: "view" },
  { path: EDIT_CHATTER_CLIENT, component: <AddClientChatter />, module: "client_chatter", action: "view" },
  { path: PRIVATE_CLIENT_LIST, component: <ClientPrivate />, module: "client_private", action: "view" },
  { path: VIEW_PRIVATE_CLIENT, component: <ClientPrivateDetail />, module: "client_private", action: "view" },
  { path: ADD_PRIVATE_CLIENT, component: <AddClientPrivate />, module: "client_private", action: "view" },
  { path: EDIT_PRIVATE_CLIENT, component: <AddClientPrivate />, module: "client_private", action: "view" },
  { path: DISCHARGES, component: <Discharges />, module: "client_discharges", action: "view" },
  { path: CLASSROOM_CONSULTATIONS, component: <ClassroomConsultations />, module: "client_discharges", action: "view" },
  {
    path: SUBADMIN_ONBOARD,
    component: <SubAdminOnboard />
  },
  {
    path: NOTIFICATIONS,
    component: <Notifications />,
  },
  {
    path: MANAGE_NOTIFICATIONS,
    component: <ManageNotifications />,
  },
  {
    path: MANAGE_NOTIFICATION_USERS,
    component: <ManageNotificationUsers />,
  },
  {
    path: MANAGE_NOTIFICATION_USER_FEED,
    component: <ManageNotificationUserFeed />,
  },
  {
    path: NOTIFICATION_TEMPLATES,
    component: <NotificationTemplates />,
  },
  {
    path: NOTIFICATION_TEMPLATES_EDIT,
    component: <EditNotifications />,
  },
  {
    path: THERAPIST_LIST,
    component: <ManageTeamTherapists />,
    module: "therapist_profile",
    action: "view",
  },
  {
    path: THERAPIST_ASSIGNED_CLIENTS,
    component: <AssignedClientsToTherapist />,
    module: "therapist_profile",
    action: "view",
  },
  {
    path: THERAPIST_ADD,
    component: <AddTherapist />,
    module: "therapist_profile",
    action: "view",
  },
  {
    path: THERAPIST_EDIT,
    component: <AddTherapist />,
    module: "therapist_profile",
    action: "view",
  },
  {
    path: THERAPIST_DETAIL,
    component: <TherapistDetail />,
    module: "therapist_profile",
    action: "view",
  },
  {
    path: DISCIPLINES_LIST,
    component: <DisciplineProfile />,
    module: "discipline_profile",
    action: "view",
  },
  {
    path: DISCIPLINES_ADD,
    component: <AddDiscipline />,
    module: "discipline_profile",
    action: "view",
  },
  {
    path: DISCIPLINES_EDIT,
    component: <AddDiscipline />,
    module: "discipline_profile",
    action: "view",
  },
  {
    path: GOALS_LIST,
    component: <AllGoals />,
    module: "goals",
    action: "view",
  },
  {
    path: GOALS_ADD,
    component: <AddGoals />,
    module: "goals",
    action: "view",
  },
  {
    path: GOALS_EDIT,
    component: <AddGoals />,
    module: "goals",
    action: "view",
  },
  {
    path: SCHOOL_BANNERS_LIST,
    component: <SchoolBannersList />,
    module: "school_banners",
    action: "view",
  },
  {
    path: SCHOOL_BANNERS_ADD,
    component: <AddBanner />,
    module: "school_banners",
    action: "view",
  },
  {
    path: SCHOOL_BANNERS_EDIT,
    component: <AddBanner />,
    module: "school_banners",
    action: "view",
  },
  {
    path: SCHOOL_BANNERS_VIEW,
    component: <ViewSchoolBanner />,
    module: "school_banners",
    action: "view",
  },
  {
    path: SCHOOL_LIST,
    component: <SchoolProfile />,
    module: "school_profile",
    action: "view",
  },
  {
    path: SCHOOL_ADD,
    component: <AddSchool />,
    module: "school_profile",
    action: "view",
  },
  {
    path: SCHOOL_EDIT,
    component: <AddSchool />,
    module: "school_profile",
    action: "view",
  },
  {
    path: SCHOOL_DIVISON_LIST,
    component: <SchoolDivision />,
    module: "school_division",
    action: "view",
  },
  {
    path: SCHOOL_DIVISON_ADD,
    component: <AddSchoolDivision />,
    module: "school_division",
    action: "view",
  },
  {
    path: SCHOOL_DIVISON_EDIT,
    component: <AddSchoolDivision />,
    module: "school_division",
    action: "view",
  },
  {
    path: DESIGNATIONS_LIST,
    component: <Designations />,
    module: "designation",
    action: "view",
  },
  {
    path: DESIGNATIONS_ADD,
    component: <AddDesignation />,
    module: "designation",
    action: "view",
  },
  {
    path: DESIGNATIONS_EDIT,
    component: <AddDesignation />,
    module: "designation",
    action: "view",
  },
  {
    path: SERVICE_STATUS_LIST,
    component: <ServiceStatus />,
    module: "service_status",
    action: "view",
  },
  {
    path: SERVICE_STATUS_ADD,
    component: <AddServiceStatus />,
    module: "service_status",
    action: "view",
  },
  {
    path: SERVICE_STATUS_EDIT,
    component: <AddServiceStatus />,
    module: "service_status",
    action: "view",
  },
  {
    path: MDT_STATUS_LIST,
    component: <ManageMDTStatus />,
    module: "mdt_status",
    action: "view",
  },
  {
    path: MDT_ASSESSMENT_DOCUMENTS,
    component: <MdtClientAttachmentsPage />,
    module: "mdt_assessment",
    action: "view",
  },
  {
    path: MDT_STATUS_ADD,
    component: <AddMDTStatus />,
    module: "mdt_status",
    action: "view",
  },
  {
    path: MDT_STATUS_EDIT,
    component: <AddMDTStatus />,
    module: "mdt_status",
    action: "view",
  },
  {
    path: MDT_TERMS_LIST,
    component: <ManageMDTTerms />,
    module: "mdt_term",
    action: "view",
  },
  {
    path: MDT_TERMS_ADD,
    component: <AddMDTTerms />,
    module: "mdt_term",
    action: "view",
  },
  {
    path: MDT_TERMS_EDIT,
    component: <AddMDTTerms />,
    module: "mdt_term",
    action: "view",
  },
  {
    path: MDT_ASSESSMENT_LIST,
    component: <Multidisciplinary />,
    module: "mdt_assessment",
    action: "view",
  },
  {
    path: MDT_ASSESSMENT_ADD,
    component: <AddMultidisciplinaryAssessment />,
    module: "mdt_assessment",
    action: "view",
  },
  {
    path: MDT_ASSESSMENT_EDIT,
    component: <AddMultidisciplinaryAssessment />,
    module: "mdt_assessment",
    action: "view",
  },
  {
    path: MDT_ASSESSMENT_DETAILS,
    component: <MultidisciplinaryDetail />,
    module: "mdt_assessment",
    action: "view",
  },
  {
    path: CHATTER_PEER_LIST,
    component: <ChatterPeer />,
    module: "chatter_peer",
    action: "view",
  },
  {
    path: CHATTER_PEER_ADD,
    component: <ChatterPeerAdd />,
    module: "chatter_peer",
    action: "view",
  },
  {
    path: CHATTER_PEER_EDIT,
    component: <ChatterPeerAdd />,
    module: "chatter_peer",
    action: "view",
  },
  {
    path: CHATTER_PEER_DETAILS,
    component: <ChatterPeerDetail />,
    module: "chatter_peer",
    action: "view",
  },
  {
    path: CHATTER_PEER_REFERENCE_LETTER,
    component: <CreatePeerReferenceLetter />,
    module: "chatter_peer",
    action: "view",
  },
  {
    path: CHATTER_PEER_REFERENCE_LETTER_V2,
    component: <VolunteerReferenceLetter />,
    module: "chatter_peer",
    action: "view",
  },
  {
    path: CHATTER_LESSON_LIST,
    component: <ChatterLessonPlan />,
    module: "chatter_lesson_plan",
    action: "view",
  },
  {
    path: CHATTER_LESSON_ADD,
    component: <ChatterLessonPlanAdd />,
    module: "chatter_lesson_plan",
    action: "view",
  },
  {
    path: CHATTER_LESSON_EDIT,
    component: <ChatterLessonPlanAdd />,
    module: "chatter_lesson_plan",
    action: "view",
  },
  {
    path: CHATTER_LESSON_DETAILS,
    component: <ChatterLessonDetail />,
    module: "chatter_lesson_plan",
    action: "view",
  },
  {
    path: CHATTER_PROGRAM_LIST,
    component: <ChatterProgramFiles />,
    module: "chatter_program",
    action: "view",
  },
  {
    path: CHATTER_PROGRAM_ADD,
    component: <AddChatterProgramFiles />,
    module: "chatter_program",
    action: "view",
  },
  {
    path: CHATTER_PROGRAM_EDIT,
    component: <AddChatterProgramFiles />,
    module: "chatter_program",
    action: "view",
  },
  {
    path: CHATTER_PROGRAM_DETAILS,
    component: <ChatterProgramFilesDetail />,
    module: "chatter_program",
    action: "view",
  },
  {
    path: FUNDING_SOURCE_LIST,
    component: <PCFundingSource />,
    module: "funding_source",
    action: "view",
  },
  {
    path: ADD_FUNDING_SOURCE,
    component: <AddFundingSource />,
    module: "funding_source",
    action: "view",
  },
  {
    path: EDIT_FUNDING_SOURCE,
    component: <AddFundingSource />,
    module: "funding_source",
    action: "view",
  },
  {
    path: VIEW_FUNDING_SOURCE,
    component: <PCFundingSourceDetail />,
    module: "funding_source",
    action: "view",
  },
  {
    path: MANAGE_PARENTS_LIST,
    component: <ManageParents />,
    module: "parent_profile",
    action: "view",
  },
  {
    path: MANAGE_PARENTS_ADD,
    component: <AddParent />,
    module: "parent_profile",
    action: "view",
  },
  {
    path: MANAGE_PARENTS_DETAILS,
    component: <ParentDetail />,
    module: "parent_profile",
    action: "view",
  },
  {
    path: MANAGE_PARENTS_EDIT,
    component: <AddParent />,
    module: "parent_profile",
    action: "view",
  },
  {
    path: CLIENT_CONSENT_FORMS_LIST,
    component: <ConsentForms />,
    // module: "consent_form",
    // action: "view",
  },
  {
    path: MANAGE_CONSENT_CHECKLISTS_LIST,
    component: <ManageConsentCheckLists />,
    // module: "consent_form",
    // action: "view",
  },
  {
    path: MANAGE_CONSENT_CHECKLISTS_ADD,
    component: <AddConsentCheckLists />,
    // module: "consent_form",
    // action: "view",
  },
  {
    path: MANAGE_CONSENT_CHECKLISTS_UPDATE,
    component: <AddConsentCheckLists />,
    // module: "consent_form",
    // action: "view",
  },
  {
    path: MANAGE_PARENT_TASKS_LIST,
    component: <ParentTasksList />,
    module: "parent_profile",
    action: "view",
  },
  {
    path: MANAGE_PARENT_TASK_SESSION_VIEW,
    component: <ParentTaskSessionView />,
    module: "parent_profile",
    action: "view",
  },
  {
    path: MANAGE_TEACHERS_LIST,
    component: <ManageTeachers />,
    module: "teacher_profile",
    action: "view",
  },
  {
    path: MANAGE_TEACHERS_ADD,
    component: <AddTeacher />,
    module: "teacher_profile",
    action: "view",
  },
  {
    path: MANAGE_TEACHERS_EDIT,
    component: <AddTeacher />,
    module: "teacher_profile",
    action: "view",
  },
  {
    path: MANAGE_COORDINATORS_LIST,
    component: <ManageCoordinators />,
    module: "coordinator_profile",
    action: "view",
  },
  {
    path: MANAGE_COORDINATORS_ADD,
    component: <AddCoordinator />,
    module: "coordinator_profile",
    action: "view",
  },
  {
    path: MANAGE_COORDINATORS_EDIT,
    component: <AddCoordinator />,
    module: "coordinator_profile",
    action: "view",
  },
  {
    path: MANAGE_SUPPORT_STAFF_LIST,
    component: <ManageSupportStaff />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_SUPPORT_STAFF_ADD,
    component: <AddSupportStaff />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_SUPPORT_STAFF_EDIT,
    component: <AddSupportStaff />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_SUPPORT_STAFF_VIEW,
    component: <SupportStaffDetails />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_SUPPORT_STAFF_CLIENT_TASKS,
    component: <ClientTasks />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_SUPPORT_STAFF_CLIENT_TASKS_SESSION_VIEW,
    component: <ClientTaskSessionView />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_STAFF_GROUP_TASK_LIST,
    component: <GroupTasks />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_STAFF_GROUP_SESSION_VIEW,
    component: <GroupTaskSession />,
    module: "support_staff_profile",
    action: "view",
  },
  {
    path: MANAGE_CMS_LIST,
    component: <ManageCms />,
    module: "cms",
    action: "view",
  },
  {
    path: MANAGE_CMS_ADD,
    component: <AddCms />,
    module: "cms",
    action: "view",
  },
  {
    path: MANAGE_CMS_EDIT,
    component: <AddCms />,
    module: "cms",
    action: "view",
  },
  {
    path: MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST,
    component: <ManageNotificationTemplate />,
    module: "email_notification",
    action: "view",
  },
  {
    path: MANAGE_NOTIFICATION_EMAIL_TEMPLATE_ADD,
    component: <AddNotificationTemplate />,
    module: "email_notification",
    action: "view",
  },
  {
    path: MANAGE_NOTIFICATION_EMAIL_TEMPLATE_EDIT,
    component: <AddNotificationTemplate />,
    module: "email_notification",
    action: "view",
  },
  {
    path: MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST,
    component: <ManageFirebaseNotificationTemplate />,
    module: "firebase_notification",
    action: "view",
  },
  {
    path: MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_ADD,
    component: <AddFirebaseNotificationTemplate />,
    module: "firebase_notification",
    action: "view",
  },
  {
    path: MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_EDIT,
    component: <AddFirebaseNotificationTemplate />,
    module: "firebase_notification",
    action: "view",
  },
  {
    path: MANAGE_USERS_LIST,
    component: <ManageSubAdmin />,
    module: "no_access_for_now",
    action: "view",
  },
  {
    path: MANAGE_USERS_VIEW,
    component: <ManageUserDetails />,
    module: "no_access_for_now",
    action: "view",
  },
  {
    path: MANAGE_USERS_ADD,
    component: <AddSubAdmin />,
    module: "no_access_for_now",
    action: "view",
  },
  {
    path: MANAGE_USERS_EDIT,
    component: <AddSubAdmin />,
    module: "no_access_for_now",
    action: "view",
  },
  {
    path: PROFILE,
    component: <Profile />,
  },
  {
    path: POLICY_AND_PROCEDURE,
    component: <PolicyAndProcedure />,
    module: "policy_and_procedures",
    action: "view",
  },
  {
    path: POLICY_AND_PROCEDURE_V2,
    component: <PoliciesAndProceduresV2 />,
    module: "policy_and_procedures_v2",
    action: "view",
  },
  {
    path: POLICY_AND_PROCEDURE_V2_ADD,
    component: <AddPolicyAndProcedureV2 />,
    module: "policy_and_procedures_v2",
    action: "add",
  },
  {
    path: POLICY_AND_PROCEDURE_V2_EDIT,
    component: <AddPolicyAndProcedureV2 />,
    module: "policy_and_procedures_v2",
    action: "edit",
  },
  {
    path: POLICY_AND_PROCEDURE_V2_DETAIL,
    component: <PolicyAndProcedureDetailV2 />,
    module: "policy_and_procedures_v2",
    action: "view",
  },
  {
    path: POLICY_AND_PROCEDURE_PREVIEW,
    component: <PolicyAndProceduresPreview />,
    module: "policy_and_procedures",
    action: "view",
  },
  {
    path: MANAGE_EXPORT,
    component: <ManageExport />,
    module: "manage_exports",
    action: "view",
  },
  {
    path: MANAGE_CONSENT_FORM,
    component: <ManageConsent />,
    module: "consent_form",
    action: "view",
  },
  {
    path: MANAGE_CONSENT_ADD,
    component: <AddConsent />,
    module: "consent_form",
    action: "view",
  },
  {
    path: MANAGE_CONSENT_EDIT,
    component: <AddConsent />,
    module: "consent_form",
    action: "view",
  },
  {
    path: VIEW_REPORT,
    component: <ViewReport />
  },
  {
    path: APPOINTMENT_ADD,
    component: <AddAppointment />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_EDIT,
    component: <AddAppointment />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_LIST,
    component: <ViewAppointment />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_DETAILS,
    component: <AppointmentDetail />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_FORMS_VIEW,
    component: <AppointmentFormsView />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_SERVICES_LIST,
    component: <AppointmentServices />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_SERVICES_ADD,
    component: <AddAppointmentServices />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_SERVICES_EDIT,
    component: <AddAppointmentServices />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_INVOICE_LIST,
    component: <AppointmentInvoices />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: APPOINTMENT_INVOICE_VIEW,
    component: <AppointmentInvoiceDetail />,
    module: "client_school_test",
    action: "view",
  },
  {
    path: CLIENT_ASSIGNED_COSNENT_FORMS_VIEW,
    component: <AssignedConsentFormView />,
    module: "consent_form",
    action: "view",
  },
  {
    path: ASSESSMENT_TEMPLATE_LIST,
    component: <AssessmentTemplates />,
    module: "report_template_assessment",
    action: "view",
  },
  {
    path: ASSESSMENT_TEMPLATE_ADD,
    component: <AssessmentTemplatesAdd />,
    module: "report_template_assessment",
    action: "view",
  },
  {
    path: ASSESSMENT_TEMPLATE_EDIT,
    component: <AssessmentTemplatesAdd />,
    module: "report_template_assessment",
    action: "view",
  },
  {
    path: CHATTER_TEMPLATE_LIST,
    component: <ChatterTemplates />,
    module: "report_template_chatter",
    action: "view",
  },
  {
    path: CHATTER_TEMPLATE_ADD,
    component: <ChatterTemplatesAdd />,
    module: "report_template_chatter",
    action: "view",
  },
  {
    path: CHATTER_TEMPLATE_EDIT,
    component: <ChatterTemplatesAdd />,
    module: "report_template_chatter",
    action: "view",
  },
  {
    path: AUDIT_LOGS,
    component: <AuditLogs />,
    module: "audit_logs",
    action: "view",
  },
  {
    path: WORKSHOPS,
    component: <Workshops />
  },
  {
    path: WORKSHOP_ADD,
    component: <AddWorkshop />
  },
  {
    path: WORKSHOP_EDIT,
    component: <AddWorkshop />
  },
  {
    path: WORKSHOP_VIEW,
    component: <WorkshopView />
  },
  // NOTES
  {
    path: NOTES_TABLE,
    component: <NotesTable />
  },
  {
    path: CREATE_NOTES,
    component: <AddNotesForm />
  },
  {
    path: EDIT_NOTES,
    component: <AddNotesForm />
  },
  // // DIAGNOSIS AND SEVERITY
  {
    path: DIAGNOSIS_SERVERITY,
    component: <DiagnosisPage />
  },
  // SERVICE STATUS 
  {
    path: CLIENT_SERVICE_STATUS_LIST,
    component: <ServiceStatusPage />
  },
  {
    path: CLINICIANS_HISTORY,
    component: <CliniciansHistory />
  },
  // // ATTENDANCE TRACK 
  {
    path: CLIENT_ATTENDANCE_LIST,
    component: <AttendanceTracker />
  },
  // // CLIENT DOCUMENTS 
  {
    path: CLIENT_DOCUMENTS_LIST,
    component: <ClientAttachmentsPage />
  },
  {
    path: CLIENT_REPORTS_LIST,
    component: <ReportsPage />
  },
  {
    path: CHATTER_CLIENT_ATTENDANCE,
    component: <ChatterAttendanceTracker />
  },

];
